import AxiosAdminAPI from "../../../../util/AxiosAdminAPI";
import {V1InvitationIDOCToArray} from "../../../../util/Payload";
import EnterpriseComponent from "../../EnterpriseComponent";

class InvitationEnterpriseComponent extends EnterpriseComponent {
    performSingleRecordRefresh = (primaryKey) => {
        let options = {
            method: "GET",
            url: "t6/v1/invitations",
            json: true,
            params: {
                "USID": primaryKey,
            },
            headers: {
                "idoc-request": "v1.Invitation-001",
            },
        };
        this.notifySingleRecordRefreshStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.refreshEnterpriseComponentSuccess(V1InvitationIDOCToArray(response.data));
            })
            .catch(error => {
                this.fetchEnterpriseComponentFailed(error);
            });
    };

    performQuery = (start, pageSize, foreignKey) => {
        let params = {};
        if (foreignKey === null) {
            params = {
                "Limit": pageSize,
                "Offset": start,
            };
        } else {
            params = {
                "Limit": pageSize,
                "Offset": start,
            };
        }

        params["Sort"] = this.getFormattedSortSpecification();

        let keys = Object.keys(this.getSearchSpecification());
        for (let i = 0; i < keys.length; i++) {
            params[keys[i]] = this.getSearchSpecification()[keys[i]];
        }

        let options = {
            method: "GET",
            url: "t6/v1/invitations",
            json: true,
            params: params,
            headers: {
                "idoc-request": "v1.Invitation-001",
            },
        };
        this.notifyLoadStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.fetchEnterpriseComponentSuccess(V1InvitationIDOCToArray(response.data), start, pageSize);
            })
            .catch(error => {
                this.fetchEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPutIDOC = () => {
        let payload = {};

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.Invitation-001";
        payload.PlatformMessage.Invitation = this.preparePUTPayload();

        return payload;
    };

    performUpdate = () => {
        let payload = this.enterpriseComponentPutIDOC();

        let options = {
            method: "PUT",
            url: "t6/v1/invitations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.Invitation-001",
                "idoc-response": "v1.Invitation-001",
            },
        };
        this.notifyUpdateStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.updateEnterpriseComponentSuccess(V1InvitationIDOCToArray(response.data));
            })
            .catch(error => {
                this.updateEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let invitation = {};

        let row = this.getBuffer().get(1)[0];

        invitation["USID"] = row.get("USID");
        invitation["UserUSID"] = row.get("UserUSID");
        invitation["InvitationStatus"] = row.get("InvitationStatus");

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.Invitation-001";
        payload.PlatformMessage.Invitation = invitation;

        return payload;
    };

    performInsert = () => {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "POST",
            url: "t6/v1/invitations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.Invitation-001",
                "idoc-response": "v1.Invitation-001",
            },
        };
        this.notifyInsertStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1InvitationIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    enterpriseComponentDeleteIDOC = () => {
        let payload = {};

        payload.PlatformMessage = {};
        payload.PlatformMessage["-idoc"] = "v1.Invitation-001";
        payload.PlatformMessage.Invitation = this.prepareDeletePayload();

        return payload;
    };

    performDelete = () => {
        let payload = this.enterpriseComponentDeleteIDOC();

        let options = {
            method: "DELETE",
            url: "t6/v1/invitations",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.Invitation-001",
                "idoc-response": "v1.Invitation-001",
            },
        };
        this.notifyDeleteStartListeners();
        AxiosAdminAPI(options)
            .then(response => {
                this.deleteEnterpriseComponentSuccess(response.data);
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default InvitationEnterpriseComponent;